import { Flex, LoadingIcon } from '@cash-design-system/react'
import { Country } from '@cash-web/protos/squareup/common/countries.pb'

import { AddressInput, AddressInputPrefill } from './AddressInput'
import { AutocompleteAddress } from './AutocompleteAddress'
import { useAutocompleteAddressInput } from './useAutocompleteAddressInput'

type AutocompleteAddressInputProps = { autoFocus?: boolean; countryCode: Country; prefill?: AddressInputPrefill }
export const AutocompleteAddressInput = ({ autoFocus, countryCode, prefill }: AutocompleteAddressInputProps) => {
  const hasAllPrefilledFields = prefill?.street && prefill?.city && prefill?.state && prefill?.postalCode
  const { isInitialInput, getPredictions, chooseAddress, placesAddress, isLoadingAddress } =
    useAutocompleteAddressInput({ isInitialInput: !hasAllPrefilledFields })

  if (countryCode !== Country.US) {
    throw new Error('AutocompleteAddressInput only supports US region.')
  }

  if (isLoadingAddress) {
    return (
      <Flex justifyContent="center">
        <LoadingIcon />
      </Flex>
    )
  } else if (isInitialInput) {
    return <AutocompleteAddress chooseAddress={chooseAddress} updateAutocompleteValue={getPredictions} />
  } else {
    return (
      <AddressInput
        autoFocus={autoFocus}
        countryCode={Country.US}
        requiresStreetAddress={true}
        requiresCity={true}
        requiresState={true}
        requiresPostalCode={true}
        prefill={placesAddress || prefill}
      />
    )
  }
}
